var MyException = /** @class */ (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());
export { MyException };
//# sourceMappingURL=multiselect.model.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular4-multiselect-dropdown/dist/multiselect.model.js
// module id = ../../../../angular4-multiselect-dropdown/dist/multiselect.model.js
// module chunks = 42